import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';
import { ActivatedRoute, Router } from "@angular/router";

import { SeguroService } from '../services/seguro.service';
import { AuthService } from '../services/auth.service';
import { VeiculoService } from '../services/veiculo.service';
import { SeguradoraService } from '../services/seguradora.service';
import { CorretoraService } from '../services/corretora.service';
import { ExcelService } from '../services/excel.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { environment } from '../../environments/environment';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

@Component({
	selector: 'app-seguro',
	templateUrl: './seguro.component.html',
	styleUrls: ['./seguro.component.css'],
	animations: [loadingFade, modal, alert]
})
export class SeguroComponent implements OnInit {

	public menu_id = 153;

	public loading = false;
	public seguros = [];
	public veiculos = [];
	public seguradoras = [];
	public corretoras = [];


	private dataAtual = moment(new Date()).format("YYYY-MM-DD");

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public formFiltro: FormGroup;
	public showFilter = true;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	
		

	public img_extensions = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];

	constructor(private fb: FormBuilder,
		private seguroSvc: SeguroService,
		private authSvc: AuthService,
		private veiculoSvc: VeiculoService,
		private seguradoraSvc: SeguradoraService,
		private corretoraSvc: CorretoraService,
		private router: Router,	
		private route: ActivatedRoute,			
		private excelSvc: ExcelService,
		private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {


		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  		


		this.criaFiltro();
		this.pegaVeiculos();
		this.pegaSeguros();
		this.pegaSeguradoras();
		this.pegaCorretoras();
	}

	criaFiltro() {
		this.formFiltro = this.fb.group({
			seguro_valor___valorMin: '',
			seguro_valor___valorMax: '',
			seguro_vigencia___data_i: null,
			seguro_vigencia___data_f: null,
			veiculo_id___veiculo_id: null,
			seguradora_id___seguradora_id: null,
			corretora_id___corretora_id: null
		});

		let campos_data = ['seguro_vigencia___data_i', 'seguro_vigencia___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}

		this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");

			  let loCorretoraId = null;
			  let loVeiculo_id = null;
			  let loData_i = "";
			  let loData_f = "";
			  let loValorMin = null;
			  let loValorMax = null;
			  let loSeguroId = null;
	  
			  //this.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "seguro_valor___valorMin": { 
	  
					if(loSplitValor[1] !== "null"){
					  this.showFilter = false;
					  loValorMin = loSplitValor[1];
					}
					 break; 
	  
				  } 
				  case "seguro_valor___valorMax": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						loValorMax = loSplitValor[1];
					}
	  
					break; 
				  }
				  case "veiculo_id___veiculo_id": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						 loVeiculo_id = parseInt(loSplitValor[1]);

					}
					 break; 
				  } 
				  case "seguro_vigencia___data_i": { 
					if(loSplitValor[1] !== "null"){
					  this.showFilter = false;
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				  case "seguro_vigencia___data_f": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						let splitDate1 = loSplitValor[1].split("-");
						if(splitDate1){
						  loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
						}
					  }
					   break; 
				  }      
				  case "corretora_id___corretora_id": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						 loCorretoraId =  loSplitValor[1];
					}
					 break; 
				  }
				  case "seguradora_id___seguradora_id": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						 loSeguroId =  parseInt(loSplitValor[1]);
					}
					 break; 
				  }				  
				 }
	  
			  }

			  this.preencheForm({
				seguro_valor___valorMin: loValorMin,
				seguro_valor___valorMax: loValorMax,
				seguro_vigencia___data_i: loData_i,
				seguro_vigencia___data_f: loData_f,
				veiculo_id___veiculo_id: loVeiculo_id,
				seguradora_id___seguradora_id: loSeguroId,
				corretora_id___corretora_id: loCorretoraId						
	  
			  });
			  this.filtra();
	  
			}
	  
		  });

	}

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
		}

	pegaSeguros() {
		this.seguros = [];
		this.loading = true;
		this.seguroSvc.getSegurosByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.seguros = data;
			this.count = this.seguros.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	pegaVeiculos() {
		this.veiculos = [];
		this.loading = true;
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
	}
	pegaSeguradoras() {
		this.seguradoras = [];
		this.loading = true;
		this.seguradoraSvc.getSeguradoras().then((data: any) => {
			this.seguradoras = data;
		}).catch((err) => {
			console.log(err);
		});
	}
	pegaCorretoras() {
		this.corretoras = [];
		this.loading = true;
		this.corretoraSvc.getCorretoras().then((data: any) => {
			this.corretoras = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	filtra() {
		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroPipe().transform(this.seguros, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
	}

	apagaSeguro(id) {
		Swal.fire({
			type: 'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'

		}).then((result) => {
			if (result.value == true) {
				this.seguroSvc.apagaSeguro(id).then((data) => {
					this.pegaSeguros();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	exportarExcel() {
		console.log(this.seguros);
		let data = [];
		if (this.dadosFiltrados.length == 0) {
			this.dadosFiltrados = this.seguros;
		}
		for (let index in this.dadosFiltrados) {
			data[index] = {
				'Veículo': this.dadosFiltrados[index].veiculo.veiculo_placa,
				'Valor': this.dadosFiltrados[index].seguro_valor.replace('.', ','),
				'Seguradora': this.dadosFiltrados[index].seguradora.seguradora_nome,
				'Corretora': this.dadosFiltrados[index].corretora != null ? this.dadosFiltrados[index].corretora.corretora_nome : '',
				'Vencimento': moment(this.dadosFiltrados[index].seguro_vigencia).format('DD/MM/YYYY'),
			};
		}

		//'Solicitante': this.dadosFiltrados[index].seguro_solicitante,
		//'Aprovador': this.dadosFiltrados[index].seguro_aprovador,
		//'Descrição': this.dadosFiltrados[index].seguro_descricao
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Seguro');
	}

	expandPanel() {
		this.showFilter = this.showFilter == true ? false : true;
	}

	openFile($id,typeFile){

		let col = "";
	
		if(typeFile == "DocVeiculo"){
		  col = "documento";
		}else if(typeFile == "apolice"){
		  col = "apolice";
		}
	
			//this.loading = true;
			this.seguroSvc.getSeguroArquivo($id,col).then((data) => {
			
				let dados = JSON.stringify(data);
				let obj = JSON.parse(dados);
	
		  if(obj.nome == null){
			Swal.fire({
			  type: 'error',
			  title: 'Ops!',
			  text: 'Não existe arquivo cadastrado!.'
			});
			return;
		  }
	
				let objectURL = "";
				let tipo = obj.nome.substring(obj.nome.length - 3)
				
				if(tipo == "pdf"){
					 objectURL = 'data:application/pdf;base64,' + obj.arquivo;
				}else{
					 objectURL = 'data:image/jpeg;base64,' + obj.arquivo;
				}			
	
				const downloadLink = document.createElement('a');
				downloadLink.href = objectURL;
				downloadLink.download = "Documento_" + obj.seguro_id;
				downloadLink.click();
				downloadLink.remove();
	
			}).catch((err) => {
				console.log(err);
				this.loading = false;
			})
	
	
	  }

	nivel(vencimento) {
		if (this.dataAtual > vencimento) {
			return 'late';
		}
		else if (this.dataAtual >= moment(vencimento).subtract('15', 'days').format('YYYY-MM-DD')) {
			return 'near';
		}
		else {
			return '';
		}
	}


	EditSeguro(seguro_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		this.router.navigate(['home/seguro/edit/' + seguro_id + params]);
	  }	


	  onClickLimparCampos(){
		this.formFiltro = this.fb.group({
			seguro_valor___valorMin: '',
			seguro_valor___valorMax: '',
			seguro_vigencia___data_i: null,
			seguro_vigencia___data_f: null,
			veiculo_id___veiculo_id: null,
			seguradora_id___seguradora_id: null,
			corretora_id___corretora_id: null
		});
	  }

}